// src/app/redux/sagas/cataloguesSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_CATALOGUES_REQUEST,
    fetchCataloguesSuccess,
    fetchCataloguesFail,

    createCatalogueSuccess,
    createCatalogueFail,

    updateCatalogueSuccess,
    updateCatalogueFail,

    deleteCatalogueSuccess,
    deleteCatalogueFail,

    setCataloguesLoading,
} from "../actions/cataloguesActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";
import { FETCH_FORMATIONS_REQUEST } from "../actions/formationsActions"; // pour refresh si besoin

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function buildCatalogueFormData(payload) {
    const fd = new FormData();

    const imageFile = payload?.imageFile || null;
    const attachFile = payload?.file || null;

    const clean = { ...payload };
    delete clean.imageFile;
    delete clean.file;

    fd.append("payload", JSON.stringify(clean));

    if (imageFile) fd.append("image", imageFile);
    if (attachFile) fd.append("file", attachFile);

    return fd;
}

export function* fetchCataloguesSaga() {
    const url = `${API_BASE_URL}/api/catalogues`;
    const uid = getUid();
    const token = getToken();

    yield put(setCataloguesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCataloguesSuccess(resp.data));
    } catch (e) {
        yield put(fetchCataloguesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCataloguesLoading(false));
    }
}

export function* createCatalogueSaga(action) {
    const url = `${API_BASE_URL}/api/catalogues`;
    const uid = getUid();
    const token = getToken();

    yield put(setCataloguesLoading(true));
    try {
        const fd = buildCatalogueFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createCatalogueSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Catalogue ajouté",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CATALOGUES_REQUEST });
        // optionnel
        yield put({ type: FETCH_FORMATIONS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout catalogue";
        yield put(createCatalogueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCataloguesLoading(false));
    }
}

export function* updateCatalogueSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/catalogues/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCataloguesLoading(true));
    try {
        const fd = buildCatalogueFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updateCatalogueSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Catalogue modifié",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CATALOGUES_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification catalogue";
        yield put(updateCatalogueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCataloguesLoading(false));
    }
}

export function* deleteCatalogueSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/catalogues/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCataloguesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteCatalogueSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Catalogue supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression catalogue";
        yield put(deleteCatalogueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCataloguesLoading(false));
    }
}


